'use client';

import Image from 'next/image';
import { signIn } from 'next-auth/react';
import { PlatformEnum } from '@/server/utils/platform-enum';

export function CTAButton() {
  return (
    <button
      type="button"
      onClick={() => signIn(PlatformEnum.TikTok, { callbackUrl: '/dashboard' })}
      className="text-lg font-semibold flex items-center gap-2 px-4 pr-6 py-3 rounded-full bg-gradient-to-r from-orange-500 to-pink-500 text-white shadow-lg hover:scale-105 transition-all duration-200"
    >
      <Image
        src="/tiktok-logo.png"
        alt="TikTok logo"
        width={30}
        height={30}
        className="w-8 h-8 object-contain"
      />
      Log in with TikTok
    </button>
  );
}
